import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AdminApp } from 'src/app/models/admin-app';
import { AgreeOn } from 'src/app/models/agree-on';
import { MemberLink, MemberList, MemberPaymentMethod, MemberProduct } from 'src/app/models/member';
import { PaymentMethod } from 'src/app/models/payment-method';
import { Product } from 'src/app/models/product';
import { MainAppService } from 'src/app/services/main-app.service';
import { AgreeDialogComponent } from '../../agree-dialog/agree-dialog.component';
import { InfoDialogComponent } from '../../info-dialog/info-dialog.component';

@Component({
  selector: 'app-member-detail',
  templateUrl: './member-detail.component.html',
  styleUrls: ['./member-detail.component.css']
})
export class MemberDetailComponent implements OnInit {

  public member:MemberList;
  public adminApp: AdminApp;
  public productStarting: number = 0;
  public productFinal: number = 0;
  public payments: number = 0;
  public balance: number = 0;

  _MemberLinks = new Array<MemberLink>();

  constructor(
    public dialog: MatDialog,
    public mainAppService: MainAppService,
    public dialogRef: MatDialogRef<MemberDetailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MemberList) {
      this.adminApp = mainAppService.adminApp;
      if(data){
        this.mainAppService.getMember(data.memberId).subscribe(member=>{
          if(member && member.responseData){
            this.member = member.responseData;
            if (!this.member.memberProducts){
              this.member.memberProducts = new Array<MemberProduct>();
            }
            if (!this.member.memberPaymentMethods){
              this.member.memberPaymentMethods = new Array<MemberPaymentMethod>();
            }
            if (!this.member.memberLinks){
              this.member.memberLinks = new Array<MemberLink>();
            }
            this.fixTotals();
            this._MemberLinks = JSON.parse(JSON.stringify( this.member.memberLinks));
          }
        });
      }
    }

  ngOnInit(): void {
  }

  addProduct(product: Product){
    var memberProduct = new MemberProduct();
    memberProduct.startingPrice = product.price;
    memberProduct.finalPrice = product.price;
    memberProduct.memberId = this.member.memberId;
    memberProduct.productId = product.productId;
    memberProduct.description = product.description + " (" + product.price + "€)" ;
    this.member.memberProducts.push(memberProduct);
    this.fixTotals();
  }

  deleteProduct(memberProduct: MemberProduct){
    this.member.memberProducts.splice(this.member.memberProducts.indexOf(memberProduct), 1);
    this.fixTotals();
  }

  addPaymentMethod(paymentMethod: PaymentMethod){
    var memberPaymentMethod = new MemberPaymentMethod();
    memberPaymentMethod.amount = Math.abs(this.balance);
    memberPaymentMethod.memberId = this.member.memberId;
    memberPaymentMethod.paymentMethodId = paymentMethod.paymentMethodId;
    memberPaymentMethod.description = paymentMethod.description;
    this.member.memberPaymentMethods.push(memberPaymentMethod);
    this.fixTotals();
  }

  deletePaymentMethod(memberPaymentMethod: MemberPaymentMethod){
    this.member.memberPaymentMethods.splice(this.member.memberPaymentMethods.indexOf(memberPaymentMethod), 1);
    this.fixTotals();
  }

  addLink(){
    var memberLink = new MemberLink();
    memberLink.memberId = this.member.memberId;
    this.member.memberLinks.push(memberLink);
  }

  deleteLink(memberLink: MemberLink){
    this.member.memberLinks.splice(this.member.memberLinks.indexOf(memberLink), 1);
  }


  fixTotals(){
    var productStarting: number = 0;
    var productFinal: number = 0;
    var payments: number = 0;

    this.member.memberProducts.forEach(_ =>{
      productStarting += _.startingPrice;
      productFinal += _.finalPrice;
    })

    this.member.memberPaymentMethods.forEach(_ => {
      payments += _.amount;
    })
    this.productStarting = productStarting;
    this.productFinal = productFinal;
    this.payments = payments;

    this.balance = payments - productFinal;
    
  }

  toggleMvpPlayer(){
    this.mainAppService.setMvpPlayer(this.member.memberId, this.member.isMvpPlayer).subscribe();
  }

  save(close: boolean){
    this.isLoading = true;
    this.mainAppService.saveMember(this.member).subscribe(response =>{
      this.isLoading = false;
      if(response && response.responseData){
        this._MemberLinks = JSON.parse(JSON.stringify( this.member.memberLinks));
        var agreeDto = new AgreeOn();
        agreeDto.title = ""
        agreeDto.text = "Saved OK!";
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '400px',
          data: agreeDto
        });
        if (close){
          this.dialog.closeAll();
        }
      } else{
        var agreeDto = new AgreeOn();
        agreeDto.title = ""
        agreeDto.text = "Error saving";
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '400px',
          data: agreeDto
        });
      }
    })
  }

  sendMemberEmail(templateId: number){
    if (JSON.stringify(this._MemberLinks) != JSON.stringify(this.member.memberLinks)){
      var agreeDto = new AgreeOn();
      agreeDto.title = ""
      agreeDto.text = "Member Links have changed! Please save first or click ok to send email without saving (some links might not be emailed though)";
      var _dialogRef = this.dialog.open(AgreeDialogComponent, {
        width: '400px',
        data: agreeDto
      });
      _dialogRef.afterClosed().subscribe(result => {
        if(result){
          this._sendMemberEmail(templateId);
        }
      });
    }else{
      this._sendMemberEmail(templateId);
    }
  }

  isLoading:boolean = false;

  _sendMemberEmail(templateId: number){
    this.isLoading = true;
    this.mainAppService.sendMemberEmail(this.member.memberId, templateId).subscribe(response =>{
      this.isLoading = false;
      if(response && response.responseData){
        var agreeDto = new AgreeOn();
        agreeDto.title = ""
        agreeDto.text = "Email Sent!";
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '400px',
          data: agreeDto
        });
      } else{
        var agreeDto = new AgreeOn();
        agreeDto.title = ""
        agreeDto.text = "Error sending email";
        const dialogRef = this.dialog.open(InfoDialogComponent, {
          width: '400px',
          data: agreeDto
        });
      }
    })
  }
}
